import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}
  transform(url: string): SafeUrl | null {
    if (!url || typeof url !== 'string') return null;
    if (url.includes('://') || url.includes('..') || url.includes('\\')) return null;
    if (url.startsWith('./assets/') || url.startsWith('/assets/')) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return null;
  }
}
